/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const KeylessIgnition = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 25 25" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M12.68.54a12.09 12.09 0 1 0 12.08 12.09C24.754 5.96 19.35.551 12.68.54zm0 22.17a10.09 10.09 0 1 1 10.08-10.08c-.011 5.562-4.518 10.069-10.08 10.08z" /><path d="M12.63 12.79a.75.75 0 0 0 .75-.75V7.2a.75.75 0 1 0-1.5 0V12a.74.74 0 0 0 .75.79z" /><path d="M16.2 8.6a.76.76 0 0 0-1.06.06.75.75 0 0 0 .06 1.06 3.88 3.88 0 1 1-5.15 0 .75.75 0 0 0-1-1.12 5.38 5.38 0 1 0 7.14 0h.01z" /></g>
      </g>
    </svg>
  </span>
);

KeylessIgnition.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

KeylessIgnition.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default KeylessIgnition;
